import { useEffect, useState } from "react";
import About from "../../components/home/About";
import Banner from "../../components/home/Banner";
import Blog from "../../components/home/Blog";
import Event from "../../components/home/Event";
import Service from "../../components/home/Service";
import axios from "axios";
import Review from "../../components/home/Review";
import Partners from "../../components/home/Partners";
import Chart from "../../components/home/Chart";
import Contact from "../../components/home/Contact";

const Home = () => {
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    axios.get("/api/blog").then((res) => setData(res.data.data));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <Banner />
      <About />
      <Service />
      <Chart />
      <Blog data={data} />
      <Event />
      <Review />
      <Contact />
      <Partners />
    </div>
  );
};

export default Home;
